var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",class:_vm.clazz},[_c('div',{staticClass:"center-both"},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.loadingText))]),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-load m-auto"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line"})])
}]

export { render, staticRenderFns }